import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequestProd, loginRequestDev } from "../authConfig";
import { DefaultButton } from '@fluentui/react/lib/Button';


export const SignInButton = (props) => {
    const { setUserSignedIn, setTokenExpired } = props;
    const { instance, accounts, inProgress } = useMsal();
    let authMsalToken = localStorage.getItem("msalToken");

    async function requestToken(instance) {
      let request;
      if(process.env.NODE_ENV === 'production') {
        request = {
          ...loginRequestProd,
          account: accounts[0],
        };
      }
      else {
        request = {
          ...loginRequestDev,
          account: accounts[0],
        };
      }
        await instance
          .acquireTokenPopup(request)
          .then((response) => {
            setTokenExpired(false);
            localStorage.setItem("msalToken", response.accessToken);
            authMsalToken = response.accessToken;
          })
          .catch((e) => {
          });

          setUserSignedIn(true);
      }

    return (
        <DefaultButton text="Sign In" onClick={() => requestToken(instance)}>Sign in</DefaultButton>
    );
}